// 섹터 택소노미 전 탭 공용 ⓘ 툴팁 문구 모음.
// 한 곳에서 관리해 Tree/Mappings/ReviewQueue/Feedback 간 표현 통일.
// 페이지 레벨 헬프 패널 (TaxonomyHelpPanel) 과 내용은 연동되지만, 여기는 1~2줄 단문.

export const TX_TOOLTIPS = {
  // TaxonomyTreeTab 컬럼 헤더.
  confirmedPending:
    'stock_canonical_sectors VIEW 는 confirmed 매핑만 집계합니다. pending 은 운영자 승인 후 반영 — 현재 대기 수는 주황색으로 표시.',

  // MappingsTab 컬럼 헤더 + ReviewQueueTab Type-C 재사용.
  mergeStrategy:
    'rename = 원천 1→1 이름 개선 · merge = N→1 통합 (merge_basis 필수) · new = 원천에 없던 상위 메타 · split 은 현재 금지.',

  relation:
    'primary_name (대표) · equivalent_synonym (동의어) · sibling_by_overlap (Jaccard 형제) · parent/child_in_source_hierarchy (상·하위) · cross_source_synonym (타 source 동의어).',

  jaccard:
    'Jaccard = 교집합 종목 수 / 합집합 종목 수 (0~1). 임계값: ≥0.70 강한 중복 (merge 권장), 0.50~0.70 의심, 0.30~0.50 약한 유사, <0.30 무관.',

  // MappingsTab 버튼 hover.
  pendingExcel:
    '3개 시트(대기 매핑 / 원본 섹터 / 승인 후 시뮬레이션) 엑셀 생성. 시뮬레이션 시트의 auto-filter 로 신뢰도 구간별 필터 가능.',

  // FeedbackTab 필터 바.
  fbKind:
    'LLM 이 붙이는 피드백 종류 — structural_gap / boundary_ambiguous / taxonomy_suggestion / data_anomaly 등.',
  fbSeverity:
    'info (참고) · suggestion (개선 제안, 비차단) · blocker (승인 차단 — 반드시 검토 후 해결).',
  fbScope:
    '피드백이 가리키는 범위 — canonical_sector (정규 섹터 전체) / mapping (매핑 1건) / source_sector (원천 섹터) / run (런 전반).',
  fbTarget:
    'sec_xxx (정규 섹터 slug) 또는 naver_theme:XYZ (원천) 형식. 클릭 시 해당 섹터·매핑 탭으로 딥링크.',
} as const;
